import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import Api from '../api/api';
import Loader from '../shared/loader';
import Enums from '../../utilities/enum';
import UploadFile from '../shared/file-uploader';
import imageUtilities from '../../utilities/imageUtilities';
import stringHelpers from '../../utilities/stringHelpers';
import { ErrorModal } from '../../utilities/errorModal';
import arrayUtilities from '../../utilities/arrayUtilities';
import { StatusThresholdRangeSlider } from '../shared/statusThresholdRangeSlider';
import { SearchSelect } from '../shared/searchSelect';
import Pagination from "../shared/pagination";
import { PcnPortalPreview } from './pcnPortalPreview';
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';
import { AppliedFilterDisplay } from '../shared/appliedFilterDisplay';
import { VehicleDataAnalyticsFiltersModal } from './filters-modals/vehicleDataAnalyticsFiltersModal';
import { Modal, Button } from 'react-bootstrap';

function OrganisationSettings(props) {
    const [settings, setSettings] = useState(null);
    const [isLoadingSettings, setIsLoadingSettings] = useState(false)
    const [errorMessage, setErrorMessage] = useState("");
    const isGlobalAdmin = props.user.isGlobalAdmin;
    const appealReceivedContentInputRef = useRef()
    const transferOfLiabilityReceivedContentInputRef = useRef()
    const appealAcceptedContentInputRef = useRef()
    const appealDeclinedContentInputRef = useRef()
    const [orgUrl, setOrgUrl] = useState("");
    const webhookApiBase = `${process.env.REACT_APP_APT_API_URL}/${props.organisationId}`;
    const [generalInEdit, setGeneralInEdit] = useState(false);
    const [disableAutomaticVehicleDetailsLookup, setDisableAutomaticVehicleDetailsLookup] = useState(false);
    const [iasInEdit, setIasInEdit] = useState(false);
    const [iasCanSave, setIasCanSave] = useState(false);
    const [iasPublicHash, setIasPublicHash] = useState(null);
    const [iasPrivateHash, setIasPrivateHash] = useState(null);

    const [poplaInEdit, setPoplaInEdit] = useState(false);
    const [poplaCanSave, setPoplaCanSave] = useState(true);
    const [poplaCodePrefixEnglandAndWales, setPoplaCodePrefixEnglandAndWales] = useState("");
    const [poplaCodePrefixScotland, setPoplaCodePrefixScotland] = useState("");
    const [poplaCodePrefixNorthernIreland, setPoplaCodePrefixNorthernIreland] = useState("");

    const [parkonomyInEdit, setParkonomyInEdit] = useState(false);
    const [parkonomyApiKey, setParkonomyApiKey] = useState("");

    const [conviousInEdit, setConviousInEdit] = useState(false);
    const [conviousApiKey, setConviousApiKey] = useState("");

    const [lookingForCarParkInEdit, setLookingForCarParkInEdit] = useState(false);
    const [lookingForCarParkApiKey, setLookingForCarParkApiKey] = useState("");

    const [newParkInEdit, setNewParkInEdit] = useState(false);
    const [newParkApiKey, setNewParkApiKey] = useState("");

    const [parksoInEdit, setParksoInEdit] = useState(false);
    const [parksoApiKey, setParksoApiKey] = useState("");

    const [ringGoInEdit, setRingGoInEdit] = useState(false);
    const [ringGoApiPublicKey, setRingGoApiPublicKey] = useState("");
    const [ringGoApiPrivateKey, setRingGoApiPrivateKey] = useState("");

    const [paymentProvider, setPaymentProvider] = useState(null);
    const [paymentProviders, setPaymentProviders] = useState(null);
    const [stripePublishableKey, setStripePublishableKey] = useState("");
    const [stripeSecretKey, setStripeSecretKey] = useState("");
    const [stripeWebhookSecret, setStripeWebhookSecret] = useState("");
    const [paymentProviderInEdit, setPaymentProviderInEdit] = useState(false);

    const [themeColour, setThemeColour] = useState('#000000');

    const [customCss, setCustomCss] = useState("");
    const [hostName, setHostName] = useState("");
    const [managePcnLogoAttachment, setManagePcnLogoAttachment] = useState(null);
    const [submitMessage, setSubmitMessage] = useState("");

    const [dataPurgingInEdit, setDataPurgingInEdit] = useState(false);
    const [allowPurgeNonPcnCameraDataMonths, setAllowPurgeNonPcnCameraDataMonths] = useState(false)
    const [purgeNonPcnCameraDataMonths, setPurgeNonPcnCameraDataMonths] = useState(6)

    const [kadoeInEdit, setKadoeInEdit] = useState(false);
    const [kadoeConnectionType, setKadoeConnectionType] = useState(0)
    const [kadoeUsername, setKadoeUsername] = useState("");
    const [kadoePassword, setKadoePassword] = useState("");
    const [kadoeEnquirerId, setKadoeEnquirerId] = useState("");
    const [kadoeApiKey, setKadoeApiKey] = useState("");

    const [payByPhoneInEdit, setPayByPhoneInEdit] = useState(false);
    const [payByPhoneUsername, setPayByPhoneUsername] = useState("");
    const [payByPhonePassword, setPayByPhonePassword] = useState("");

    const [justParkInEdit, setJustParkInEdit] = useState(false);
    const [justParkApiKey, setJustParkApiKey] = useState("");

    const [tap2ParkInEdit, setTap2ParkInEdit] = useState(false);
    const [tap2ParkApiKey, setTap2ParkApiKey] = useState("");

    const [parkbunnyInEdit, setParkbunnyInEdit] = useState(false);
    const [parkbunnyApiKey, setParkbunnyApiKey] = useState("");

    const [ipsInEdit, setIpsInEdit] = useState(false);
    const [ipsApiKey, setIpsApiKey] = useState("");

    const [myCarPassInEdit, setMyCarPassInEdit] = useState(false);
    const [myCarPassApiKey, setMyCarPassApiKey] = useState("");

    const [ipcInEdit, setIpcInEdit] = useState(false);
    const [ipcDataExportEnabled, setIpcDataExportEnabled] = useState(false);
    const [ipcDataExportHostName, setIpcDataExportHostName] = useState("");
    const [ipcDataExportUsername, setIpcDataExportUsername] = useState("");
    const [ipcDataExportPassword, setIpcDataExportPassword] = useState("");
    const [ipcDataExportBucket, setIpcDataExportBucket] = useState("");
    const [ipcDataExportEncryptionKey, setIpcDataExportEncryptionKey] = useState("");
    const [ipcDataExportStaticIv, setIpcDataExportStaticIv] = useState("");

    const [ftpInEdit, setFtpInEdit] = useState(false);
    const [ftpUsername, setFtpUsername] = useState("");
    const [ftpPassword, setFtpPassword] = useState("");

    const [debtRecoveryInEdit, setDebtRecoveryInEdit] = useState(false);    
    const [readyForDebtRecoveryDays, setReadyForDebtRecoveryDays] = useState(0)
    const [enableTransfer360, setEnableTransfer360] = useState(false)
    const [transfer360InEdit, setTransfer360InEdit] = useState(false)

    const [emailSettingsInEdit, setEmailSettingsInEdit] = useState(false)
    const [emailsEnabled, setEmailsEnabled] = useState(false)
    const [emailSenderName, setEmailSenderName] = useState("")
    const [emailSenderAddress, setEmailSenderAddress] = useState("")
    const [appealReceivedSubject , setAppealReceivedSubject] = useState("")
    const [appealReceivedContent, setAppealReceivedContent] = useState("")
    const [transferOfLiabilityReceivedSubject , setTransferOfLiabilityReceivedSubject] = useState("")
    const [transferOfLiabilityReceivedContent, setTransferOfLiabilityReceivedContent] = useState("")
    const [appealAcceptedResponseSubject, setAppealAcceptedResponseSubject] = useState("")
    const [appealAcceptedResponseStatus, setAppealAcceptedResponseStatus] = useState("")
    const [appealAcceptedResponseContent, setAppealAcceptedResponseContent] = useState("")
    const [appealDeclinedResponseSubject, setAppealDeclinedResponseSubject] = useState("")
    const [appealDeclinedResponseStatus, setAppealDeclinedResponseStatus] = useState("")
    const [appealDeclinedResponseContent, setAppealDeclinedResponseContent] = useState("")
    const [appealAcceptedResponseResetDateIssued, setAppealAcceptedResponseResetDateIssued] = useState(false)
    const [appealAcceptedResponseResetCharges, setAppealAcceptedResponseResetCharges] = useState(false)
    const [appealAcceptedResponseAdditionalCharge, setAppealAcceptedResponseAdditionalCharge] = useState(0)
    const [appealAcceptedResponseAdditionalChargeType, setAppealAcceptedResponseAdditionalChargeType] = useState(0)
    const [appealAcceptedResponseDebtRecoveryCharge, setAppealAcceptedResponseDebtRecoveryCharge] = useState(0)
    const [appealAcceptedResponseDebtRecoveryChargeType, setAppealAcceptedResponseDebtRecoveryChargeType] = useState(0)
    const [appealDeclinedResponseResetDateIssued, setAppealDeclinedResponseResetDateIssued] = useState(false)
    const [appealDeclinedResponseResetCharges, setAppealDeclinedResponseResetCharges] = useState(false)
    const [appealDeclinedResponseAdditionalCharge, setAppealDeclinedResponseAdditionalCharge] = useState(0)
    const [appealDeclinedResponseAdditionalChargeType, setAppealDeclinedResponseAdditionalChargeType] = useState(0)
    const [appealDeclinedResponseDebtRecoveryCharge, setAppealDeclinedResponseDebtRecoveryCharge] = useState(0)
    const [appealDeclinedResponseDebtRecoveryChargeType, setAppealDeclinedResponseDebtRecoveryChargeType] = useState(0)
    const [placeholders, setPlaceholders] = useState(null);

    const [deviceStatusInEdit, setDeviceStatusInEdit] = useState(false)
    const [cameraStatusWarningThreshold, setCameraStatusWarningThreshold] = useState("")
    const [cameraStatusDangerThreshold, setCameraStatusDangerThreshold] = useState("")
    const [kioskStatusWarningThreshold, setKioskStatusWarningThreshold] = useState("")
    const [kioskStatusDangerThreshold, setKioskStatusDangerThreshold] = useState("")

    const [searchQuery, setSearchQuery] = useState("")
    const [selectedSites, setSelectedSites] = useState([]);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false)
    const [isLoadingSites, setIsLoadingSites] = useState(false)
    const [selectedClient, setSelectedClient] = useState("");
    const [sitesByClient, setSitesByClient] = useState([])
    const [vehicleAnalyticsInEdit, setVehicleAnalyticsInEdit] = useState(false)
    const [vehicleAnalyticsEnabled, setVehicleAnalyticsEnabled] = useState(false)
    const [vehicleAnalyticsPageNumber, setVehicleAnalyticsPageNumber] = useState(0);
    const [showVehicleAnalyticsFiltersModal, setShowVehicleAnalyticsFiltersModal] = useState(false);
    const [showVehicleAnalyticsFilterPills, setShowVehicleAnalyticsFilterPills] = useState(false);
    const [vehicleAnalyticsAppliedFilters, setVehicleAnalyticsAppliedFilters] = useState(null);

    const [clientPortalInEdit, setClientPortalInEdit] = useState(false)
    const [clientAllowedVrmStartDateRequired, setClientAllowedVrmStartDateRequired] = useState(false)
    const [randomStringGenerationConfig, setRandomStringGenerationConfig] = useState(null)
    
    const previewRef = useRef()
    const customCssTimeout = useRef()
    const getOrgSettings = function () {
        setIsLoadingSettings(true)
        Api.getOrganisationSettings(
            (data) => {
                setSettings(data)
                setIsLoadingSettings(false)
            },
            (error) => {
                console.log(error)
                setIsLoadingSettings(false)
            },
            props.organisationId,
            props.token
        )
    };

    const edit = function () {
        Api.editOrganisationSettings(
            (data) => {
                setGeneralInEdit(false);
                setParkonomyInEdit(false);
                setRingGoInEdit(false);
                setIasInEdit(false);
                setPoplaInEdit(false);
                setPaymentProviderInEdit(false);
                setKadoeInEdit(false);
                setJustParkInEdit(false);
                setTap2ParkInEdit(false);
                setPayByPhoneInEdit(false);
                setParkbunnyInEdit(false);
                setMyCarPassInEdit(false);
                setConviousInEdit(false);
                setLookingForCarParkInEdit(false);
                setNewParkInEdit(false);
                setParksoInEdit(false);
                setIpcInEdit(false);
                setDataPurgingInEdit(false);
                setDebtRecoveryInEdit(false)
                setIpsInEdit(false)
                setEmailSettingsInEdit(false)
                setDeviceStatusInEdit(false)
                setVehicleAnalyticsInEdit(false)
                setClientPortalInEdit(false)
                setTransfer360InEdit(false)
                setFtpInEdit(false)
                setSettings(data);
                setSubmitMessage("Successful Edit.")
            },
            (error) => setErrorMessage(error),
            parkonomyApiKey, iasPrivateHash, iasPublicHash, paymentProvider, stripePublishableKey, stripeSecretKey, stripeWebhookSecret,
            themeColour, customCss, !stringHelpers.isNullOrEmpty(managePcnLogoAttachment?.id) ? managePcnLogoAttachment.id : null, hostName, kadoeConnectionType, 
            kadoeUsername, 
            kadoePassword, 
            kadoeEnquirerId, 
            kadoeApiKey,
            ringGoApiPrivateKey, ringGoApiPublicKey, justParkApiKey, tap2ParkApiKey, payByPhoneUsername, payByPhonePassword, parkbunnyApiKey, conviousApiKey, allowPurgeNonPcnCameraDataMonths ? purgeNonPcnCameraDataMonths : 0, disableAutomaticVehicleDetailsLookup,
            ipcDataExportEnabled, ipcDataExportHostName, ipcDataExportUsername, ipcDataExportPassword, ipcDataExportBucket, ipcDataExportEncryptionKey, ipcDataExportStaticIv, Number(readyForDebtRecoveryDays), ipsApiKey,
            emailsEnabled, emailSenderName, emailSenderAddress, appealReceivedSubject, appealReceivedContent, transferOfLiabilityReceivedSubject, transferOfLiabilityReceivedContent,
            cameraStatusWarningThreshold, cameraStatusDangerThreshold, kioskStatusWarningThreshold, kioskStatusDangerThreshold, vehicleAnalyticsEnabled,
            clientAllowedVrmStartDateRequired,
            lookingForCarParkApiKey,
            newParkApiKey,
            enableTransfer360,
            ftpUsername,
            ftpPassword,
            parksoApiKey,
            poplaCodePrefixEnglandAndWales,
            poplaCodePrefixScotland,
            poplaCodePrefixNorthernIreland,
            myCarPassApiKey,
            appealAcceptedResponseSubject, 
            appealAcceptedResponseStatus !== "" ? appealAcceptedResponseStatus : null,
            appealAcceptedResponseContent,
            appealDeclinedResponseSubject,
            appealDeclinedResponseStatus !== "" ? appealDeclinedResponseStatus : null,
            appealDeclinedResponseContent,
            appealAcceptedResponseResetDateIssued,
            appealAcceptedResponseResetCharges,
            appealAcceptedResponseAdditionalCharge !== "" ? Number(appealAcceptedResponseAdditionalCharge) : null,
            appealAcceptedResponseAdditionalChargeType,
            appealAcceptedResponseDebtRecoveryCharge !== "" ? Number(appealAcceptedResponseDebtRecoveryCharge) : null,
            appealAcceptedResponseDebtRecoveryChargeType,
            appealDeclinedResponseResetDateIssued,
            appealDeclinedResponseResetCharges,
            appealDeclinedResponseAdditionalCharge !== "" ? Number(appealDeclinedResponseAdditionalCharge) : null,
            appealDeclinedResponseAdditionalChargeType,
            appealDeclinedResponseDebtRecoveryCharge !== "" ? Number(appealDeclinedResponseDebtRecoveryCharge) : null,
            appealDeclinedResponseDebtRecoveryChargeType,
            props.organisationId,
            props.token
        );
        Api.enableVehicleAnalytics(
            selectedSites, props.organisationId,
            () => getSites("", null, vehicleAnalyticsPageNumber),
            error => console.log(error),
            props.token
        )
    };

    const getPaymentProviders = function () {
        var temp = [];
        for (let index = 0; index => 0; index++) {
            if (Enums.PaymentProvider[index] !== undefined) {
                temp.push(index);
            } else {
                break;
            }
        }
        setPaymentProviders(temp);
    };

    const formatCharge = function (charge, chargeType) {
        if (chargeType === 1) {
            return stringHelpers.formatDecimal(charge, 2) + "%";
        }
        return stringHelpers.formatDecimal(charge, 2, "£");
    };

    const getPlaceholders = function () {
        Api.getTemplatePlaceholders(
            (data) => setPlaceholders(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    };

    useEffect(() => {
        if (settings !== null) {
            setDisableAutomaticVehicleDetailsLookup(settings.disableAutomaticVehicleDetailsLookup)
            setParkonomyApiKey(settings.parkonomyApiKey)
            setConviousApiKey(settings.conviousApiKey)
            setLookingForCarParkApiKey(settings.lookingForCarParkApiKey)
            setNewParkApiKey(settings.newParkApiKey)
            setParksoApiKey(settings.parksoApiKey)
            setRingGoApiPrivateKey(settings.ringGoApiPrivateKey);
            setRingGoApiPublicKey(settings.ringGoApiPublicKey);
            setIasPrivateHash(settings.iasPrivateHash)
            setIasPublicHash(settings.iasPublicHash)
            setPoplaCodePrefixEnglandAndWales(settings.poplaCodePrefixEnglandAndWales)
            setPoplaCodePrefixScotland(settings.poplaCodePrefixScotland)
            setPoplaCodePrefixNorthernIreland(settings.poplaCodePrefixNorthernIreland)
            setPaymentProvider(settings.paymentProvider)
            setStripeSecretKey(settings.stripeSecretKey)
            setStripePublishableKey(settings.stripePublishableKey)
            setStripeWebhookSecret(settings.stripeWebhookSecret)
            if (settings.themeColour !== null) {
                setThemeColour(settings.themeColour);
            }
            setCustomCss(settings.managePcnCustomCss);
            if (settings.managePcnLogoAttachment !== null && settings.managePcnLogoAttachment !== undefined) {
                setManagePcnLogoAttachment(settings.managePcnLogoAttachment);
            }            
            setHostName(settings.managePcnHostName);
            setKadoeConnectionType(settings.kadoeConnectionType)
            setKadoeApiKey(settings.kadoeApiKey);
            setKadoeUsername(settings.kadoeUsername);
            setKadoePassword(settings.kadoePassword);
            setKadoeEnquirerId(settings.kadoeEnquirerId);
            setJustParkApiKey(settings.justParkApiKey);
            setTap2ParkApiKey(settings.tap2ParkApiKey);
            setParkbunnyApiKey(settings.parkBunnyApiKey);
            setMyCarPassApiKey(settings.myCarPassApiKey);
            setPayByPhoneUsername(settings.payByPhoneUsername);
            setPayByPhonePassword(settings.payByPhonePassword);
            setPurgeNonPcnCameraDataMonths(settings.purgeNonPcnCameraDataMonths >=1 ? settings.purgeNonPcnCameraDataMonths : 6)
            setAllowPurgeNonPcnCameraDataMonths(settings.purgeNonPcnCameraDataMonths >= 1 ? true : false)
            setIpcDataExportEnabled(settings.ipcDataExportEnabled);
            setIpcDataExportHostName(settings.ipcDataExportHostName);
            setIpcDataExportUsername(settings.ipcDataExportUsername);
            setIpcDataExportPassword(settings.ipcDataExportPassword);
            setIpcDataExportBucket(settings.ipcDataExportBucket);
            setIpcDataExportEncryptionKey(settings.ipcDataExportEncryptionKey);
            setIpcDataExportStaticIv(settings.ipcDataExportStaticIv);
            setFtpUsername(settings.ftpUsername);
            setFtpPassword(settings.ftpPassword);
            setReadyForDebtRecoveryDays(settings.readyForDebtRecoveryDays)
            setIpsApiKey(settings.ipsApiKey)
            setEmailsEnabled(settings.emailsEnabled);
            setEmailSenderName(settings.emailSenderName);
            setEmailSenderAddress(settings.emailSenderAddress);
            setAppealReceivedSubject(settings.appealReceivedSubject);
            setAppealReceivedContent(settings.appealReceivedContent);
            setTransferOfLiabilityReceivedSubject(settings.transferOfLiabilityReceivedSubject);
            setTransferOfLiabilityReceivedContent(settings.transferOfLiabilityReceivedContent);
            setCameraStatusWarningThreshold(settings.cameraStatusWarningThreshold)
            setCameraStatusDangerThreshold(settings.cameraStatusDangerThreshold)
            setKioskStatusWarningThreshold(settings.kioskStatusWarningThreshold)
            setKioskStatusDangerThreshold(settings.kioskStatusDangerThreshold)
            setVehicleAnalyticsEnabled(settings.vehicleAnalyticsEnabled)
            setClientAllowedVrmStartDateRequired(settings.clientAllowedVrmStartDateRequired)
            setEnableTransfer360(settings.enableTransfer360)

            const targetId = window.location.hash.replace('#', '')
            const targetElement = targetId ? document.getElementById(targetId) : null
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
            setAppealAcceptedResponseSubject(settings.appealAcceptedResponseSubject)
            setAppealAcceptedResponseStatus(settings.appealAcceptedResponseStatus ?? "")
            setAppealAcceptedResponseContent(settings.appealAcceptedResponseContent)
            setAppealDeclinedResponseSubject(settings.appealDeclinedResponseSubject)
            setAppealDeclinedResponseStatus(settings.appealDeclinedResponseStatus ?? "")
            setAppealDeclinedResponseContent(settings.appealDeclinedResponseContent)
            setAppealAcceptedResponseResetDateIssued(settings.appealAcceptedResponseResetDateIssued)
            setAppealAcceptedResponseResetCharges(settings.appealAcceptedResponseResetCharges)
            setAppealAcceptedResponseAdditionalCharge(settings.appealAcceptedResponseAdditionalCharge)
            setAppealAcceptedResponseAdditionalChargeType(settings.appealAcceptedResponseAdditionalChargeType)
            setAppealAcceptedResponseDebtRecoveryCharge(settings.appealAcceptedResponseDebtRecoveryCharge)
            setAppealAcceptedResponseDebtRecoveryChargeType(settings.appealAcceptedResponseDebtRecoveryChargeType)
            setAppealDeclinedResponseResetDateIssued(settings.appealDeclinedResponseResetDateIssued)
            setAppealDeclinedResponseResetCharges(settings.appealDeclinedResponseResetCharges)
            setAppealDeclinedResponseAdditionalCharge(settings.appealDeclinedResponseAdditionalCharge)
            setAppealDeclinedResponseAdditionalChargeType(settings.appealDeclinedResponseAdditionalChargeType)
            setAppealDeclinedResponseDebtRecoveryCharge(settings.appealDeclinedResponseDebtRecoveryCharge)
            setAppealDeclinedResponseDebtRecoveryChargeType(settings.appealDeclinedResponseDebtRecoveryChargeType)
        }
    }, [settings]);

    useEffect(() => {
        if (iasPublicHash !== null && iasPublicHash !== "" && iasPrivateHash !== null && iasPrivateHash !== "" && stringHelpers.lengthValidation(iasPublicHash, 50) && stringHelpers.lengthValidation(iasPrivateHash, 50)) {
            setIasCanSave(true);
        } else {
            setIasCanSave(false);
        }
    }, [iasPrivateHash, iasPublicHash]);

    useEffect(() => {
        setPoplaCanSave(
            stringHelpers.lengthValidation(poplaCodePrefixEnglandAndWales, 3) &&
            stringHelpers.lengthValidation(poplaCodePrefixScotland, 3) &&
            stringHelpers.lengthValidation(poplaCodePrefixNorthernIreland, 3)
        );
    }, [poplaCodePrefixEnglandAndWales, poplaCodePrefixScotland, poplaCodePrefixNorthernIreland]);

    useEffect(() => {
        getOrgSettings();
        getPaymentProviders();
        setOrgUrl("/organisation/" + props.organisationId)
        getPlaceholders()
        getSites("", null, 0)
    }, []);

    const resetStyles = function () {
        setCustomCss("");
    };

    useEffect(() => {
        if (customCssTimeout.current) {
            clearTimeout(customCssTimeout.current);
            customCssTimeout.current = null;
        }

        customCssTimeout.current = setTimeout(() => {
            if (!previewRef.current) return;

            // Remove the previously injected style tag (if any) so styles don't accumulate on every keystroke.
            // We identify it by the data-custom attribute set when we create it below.
            const existing = previewRef.current.querySelector('style[data-custom]');
            if (existing) existing.remove();

            if (!customCss?.trim()) return;

            // <style> tags apply globally to the document regardless of where in the DOM they are appended.
            // To prevent the user's custom CSS from leaking into the rest of the admin UI, we prefix every
            // selector with .pcn-shell so rules only apply inside the preview component.
            // e.g. "p { color: red }" becomes ".pcn-shell p { color: red }"
            const scopedCss = customCss.split('}').map(block => {
                const bracketIdx = block.indexOf('{');
                if (bracketIdx === -1) return block;
                const selector = block.substring(0, bracketIdx);
                const body = block.substring(bracketIdx);
                // Leave at-rules (@media, @keyframes etc.) untouched — they aren't selectors.
                if (selector.trim().startsWith('@')) return block;
                // Handle comma-separated selectors by scoping each one individually.
                const scoped = selector.split(',')
                    .map(s => s.trim() ? `.pcn-shell ${s.trim()}` : '')
                    .filter(Boolean)
                    .join(', ');
                return `${scoped}${body}`;
            }).join('}');

            const style = document.createElement('style');
            // Mark the tag so we can find and remove it on the next change (see above).
            style.setAttribute('data-custom', '');
            style.innerHTML = scopedCss;
            previewRef.current.appendChild(style);
        }, 400);
    }, [customCss]);

    const generateNewKadoePassword = () => {
        Api.generateKadoePassword(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getOrgSettings()
                }
            },
            error => setErrorMessage(error.errorMessage),
            props.organisationId,
            props.token
        )
    }

    const generateNewKadoeApiKey = () => {
        Api.generateKadoeApiKey(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getOrgSettings()
                }
            },
            error => setErrorMessage(error.errorMessage),
            props.organisationId,
            props.token
        )
    }
    var _sitesAbortController = null;

    const getSites = (query, clientId, page) => {
        setIsLoadingSites(true)
        if (_sitesAbortController) {
            _sitesAbortController.abort();
        }
        _sitesAbortController = new AbortController();
        const signal = _sitesAbortController.signal;
        Api.searchSites(
            (data) => {
                setSitesByClient(data.items);
                setIsLoadingSites(false)
                setSelectedSites(data.items.filter(item => item.vehicleAnalyticsEnabled).map(item => item.id))
            },
            (error) => {
                console.log(error)
                setSitesByClient([]);
                setIsLoadingSites(false)
            },
            query,
            page,
            !stringHelpers.isNullOrEmpty(clientId) ? clientId : null,
            null,
            null,
            null,
            props.organisationId,
            props.token,
            signal
        );
    };
    const showPayByPhoneUsernameGenerateButton = stringHelpers.isNullOrEmpty(settings?.payByPhoneUsername)

    return (
        <>
            {isLoadingSettings && <Loader />}{settings && settings !== null && <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">Organisation Settings</h5>
                                        </div>
                                        <div className="col-auto">
                                            <Link className="btn btn-falcon-default btn-sm mr-1 py-1" type="button" to={orgUrl}><i className="fas fa-reply"></i> Back</Link>
                                        </div>
                                    </div>
                                </div>
                                {errorMessage !== "" &&
                                    <div className="card-body bg-light border-top details-container">
                                        <div className="row">
                                            <div className="offset-md-3 col-md-6">
                                                <p className="error-message">
                                                    {errorMessage}
                                                </p>
                                            </div>
                                        </div>
                                    </div>}
                                {submitMessage !== "" &&
                                    <div className="card-body bg-light border-top details-container">
                                        <div className="row justify-content-center">
                                            <div className="col-auto">
                                                <h5 className="text-success">
                                                    {submitMessage}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>}
                            </div>
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">General</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (generalInEdit) {
                                                    setDisableAutomaticVehicleDetailsLookup(settings.disableAutomaticVehicleDetailsLookup)
                                                }
                                                setGeneralInEdit(!generalInEdit)}
                                                }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!generalInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Disable Automatic Vehicle Look-Up</p>
                                            </div>
                                            <div className="col-md-6 col-12 pt-1">
                                                {disableAutomaticVehicleDetailsLookup && <i className="fas fa-check text-success"></i>}{!disableAutomaticVehicleDetailsLookup && <i className="fas fa-times text-danger"></i>}
                                            </div>
                                        </div>
                                    </>}
                                    {generalInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Disable Automatic Vehicle Look-Up</p>
                                            </div>
                                            <div className=" col-md-6 col-12 custom-control custom-switch">
                                                <input className="custom-control-input" type="checkbox" id="automatic-look-up" checked={disableAutomaticVehicleDetailsLookup} onChange={() => setDisableAutomaticVehicleDetailsLookup(!disableAutomaticVehicleDetailsLookup)} />
                                                <label className="custom-control-label custom-toggle ml-3" htmlFor="automatic-look-up"></label>
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                {
                                    generalInEdit &&
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setDisableAutomaticVehicleDetailsLookup(settings.disableAutomaticVehicleDetailsLookup);
                                                        setGeneralInEdit(false)
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="card mb-3" id="pcn-portal-settings">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">Theme Settings</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container color-picker-container">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="row mb-3">
                                                <div className="col-4">
                                                    <p className="font-weight-semi-bold m-0 mt-1">PCN Host Name</p>
                                                </div>
                                                <div className="col-8">
                                                    <div className="form-group mb-0">
                                                        <input value={hostName} className="form-control m-0" type="text" onChange={(e) => setHostName(e.target.value)} />
                                                        { !stringHelpers.lengthValidation(hostName, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-4">
                                                    <p className="font-weight-semi-bold mt-1 mb-1">Logo</p>
                                                </div>
                                                <div className="col-8 d-flex align-items-center">
                                                    <button className="btn btn-falcon-default btn-sm" data-toggle="modal" data-target="#select-organisation-logo">Select Logo</button>
                                                    <p className='m-0 ml-3 fs-1'>{managePcnLogoAttachment?.filename}</p>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-4">
                                                    <p className="font-weight-semi-bold mb-0 mt-1">Theme Colour</p>
                                                </div>
                                                <div className="col-8 d-flex align-items-center">
                                                    <input onChange={e => {
                                                        setThemeColour(e.target.value)
                                                    }} type='color' value={themeColour} />
                                                    <p className='m-0 ml-2'>{themeColour}</p>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-4">
                                                    <p className="font-weight-semi-bold mb-1 mt-1">Add custom CSS</p>
                                                </div>
                                                <div className="col-8">
                                                    <div className="form-group mb-1">
                                                        <textarea className="form-control mb-0" rows={6} type="text" value={customCss} onChange={(e) => setCustomCss(e.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal fade save-dialog success-dialog" id="select-organisation-logo" tabIndex="-1" role="dialog">
                                                <UploadFile onSuccess={(file) => setManagePcnLogoAttachment(file)} type="Logo" organisationId={props.organisationId} />
                                            </div>
                                            <div className="row">
                                                <div className='col-4'></div>
                                                <div className="col-8">
                                                    <button className="btn btn-sm btn-falcon-default mx-1" onClick={() => resetStyles()}><i className="fas fa-times"></i> Reset</button>
                                                    <button disabled={!stringHelpers.lengthValidation(hostName, 50)} className="btn btn-sm btn-success mx-1" onClick={() => edit()}><i className="fas fa-check"></i> Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <PcnPortalPreview
                                                previewRef={previewRef}
                                                themeColour={themeColour}
                                                logoUrl={managePcnLogoAttachment?.url}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card mb-3" id="ipc-bpa-settings">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">IAS Settings</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (iasInEdit) {
                                                    setIasPublicHash(settings.iasPublicHash);
                                                    setIasPrivateHash(settings.iasPrivateHash)
                                                }
                                                setIasInEdit(!iasInEdit)}
                                                }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!iasInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">IAS Public Hash</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{iasPublicHash}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">IAS Private Hash</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{iasPrivateHash}</div>
                                        </div>
                                    </>}
                                    {iasInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">IAS Public Hash</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={iasPublicHash} onChange={(e) => setIasPublicHash(e.target.value)} />
                                                    { !stringHelpers.lengthValidation(iasPublicHash, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">IAS Private Hash</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={iasPrivateHash} onChange={(e) => setIasPrivateHash(e.target.value)} />
                                                    { !stringHelpers.lengthValidation(iasPrivateHash, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                {iasInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => {
                                                        setIasPublicHash(settings.iasPublicHash);
                                                        setIasPrivateHash(settings.iasPrivateHash)
                                                        setIasInEdit(false)
                                                    } }>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" disabled={!iasCanSave} onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                            <div className="card mb-3" id="popla-settings">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">POPLA Code Prefixes</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (poplaInEdit) {
                                                    setPoplaCodePrefixEnglandAndWales(settings.poplaCodePrefixEnglandAndWales);
                                                    setPoplaCodePrefixScotland(settings.poplaCodePrefixScotland);
                                                    setPoplaCodePrefixNorthernIreland(settings.poplaCodePrefixNorthernIreland);
                                                }
                                                setPoplaInEdit(!poplaInEdit)}
                                                }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!poplaInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">England and Wales</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{poplaCodePrefixEnglandAndWales}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Scotland</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{poplaCodePrefixScotland}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Northern Ireland</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{poplaCodePrefixNorthernIreland}</div>
                                        </div>
                                    </>}
                                    {poplaInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">England and Wales</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" maxLength={3} value={poplaCodePrefixEnglandAndWales} onChange={(e) => setPoplaCodePrefixEnglandAndWales(e.target.value)} />
                                                    { !stringHelpers.lengthValidation(poplaCodePrefixEnglandAndWales, 3) && <small className='text-danger'>This field cannot exceed 3 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Scotland</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" maxLength={3} value={poplaCodePrefixScotland} onChange={(e) => setPoplaCodePrefixScotland(e.target.value)} />
                                                    { !stringHelpers.lengthValidation(poplaCodePrefixScotland, 3) && <small className='text-danger'>This field cannot exceed 3 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Northern Ireland</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" maxLength={3} value={poplaCodePrefixNorthernIreland} onChange={(e) => setPoplaCodePrefixNorthernIreland(e.target.value)} />
                                                    { !stringHelpers.lengthValidation(poplaCodePrefixNorthernIreland, 3) && <small className='text-danger'>This field cannot exceed 3 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                {poplaInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => {
                                                        setPoplaCodePrefixEnglandAndWales(settings.poplaCodePrefixEnglandAndWales);
                                                        setPoplaCodePrefixScotland(settings.poplaCodePrefixScotland);
                                                        setPoplaCodePrefixNorthernIreland(settings.poplaCodePrefixNorthernIreland);
                                                        setPoplaInEdit(false)
                                                    } }>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" disabled={!poplaCanSave} onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                            <div className="card mb-3" id="payment-provider-settings">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">Payment Provider Settings</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (paymentProviderInEdit) {
                                                    setPaymentProvider(settings.paymentProvider);
                                                    setStripePublishableKey(settings.stripePublishableKey);
                                                    setStripeSecretKey(settings.stripeSecretKey)
                                                    setStripeWebhookSecret(settings.stripeWebhookSecret)
                                                }
                                                setPaymentProviderInEdit(!paymentProviderInEdit)}
                                                }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!paymentProviderInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Payment Provider</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{Enums.PaymentProvider[paymentProvider]}</div>
                                        </div>
                                        {paymentProvider === 0 && <>
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold  mb-3">Stripe Publishable Key</p>
                                                </div>
                                                <div className="col-md-6 col-12 ">{stripePublishableKey}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold  mb-3">Stripe Secret Key</p>
                                                </div>
                                                <div className="col-md-6 col-12 ">{stripeSecretKey}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold  mb-3">Stripe Webhook Secret</p>
                                                </div>
                                                <div className="col-md-6 col-12 ">{stripeWebhookSecret}</div>
                                            </div>
                                        </>}
                                    </>}
                                    {paymentProviderInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Payment Provider</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-1">
                                                    <div className="dropdown ">
                                                        <button className="btn btn-falcon-default dropdown-toggle btn-sm mb-0 edit-dropdown" id="select-type" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{paymentProvider !== null && <>{Enums.PaymentProvider[paymentProvider]}</>}{paymentProvider === null && <>Select Payment Provider</>}</button>
                                                        <div className="dropdown-menu py-0 edit-dropdown" aria-labelledby="select-type" >
                                                            <div className="bg-white py-2 rounded-soft">
                                                                {paymentProviders !== null && paymentProviders.map((item, i = 0) => {
                                                                    i++;
                                                                    return (
                                                                        <button className="dropdown-item text-base px-3 py-2" onClick={() => setPaymentProvider(i - 1)}>{Enums.PaymentProvider[item]}</button>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {paymentProvider === 0 && <>
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold mb-1">Stripe Publishable Key</p>
                                                </div>
                                                <div className="col-md-6 col-12">
                                                    <div className="form-group mb-0">
                                                        <input className="form-control mb-1" type="text" value={stripePublishableKey} onChange={(e) => setStripePublishableKey(e.target.value)} />
                                                        { !stringHelpers.lengthValidation(stripePublishableKey, 150) && <small className='text-danger'>This field cannot exceed 150 characters.</small> }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold mb-1">Stripe Secret Key</p>
                                                </div>
                                                <div className="col-md-6 col-12">
                                                    <div className="form-group mb-0">
                                                        <input className="form-control mb-1" type="text" value={stripeSecretKey} onChange={(e) => setStripeSecretKey(e.target.value)} />
                                                        { !stringHelpers.lengthValidation(stripeSecretKey, 150) && <small className='text-danger'>This field cannot exceed 150 characters.</small> }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold mb-1">Stripe Webhook Secret</p>
                                                </div>
                                                <div className="col-md-6 col-12">
                                                    <div className="form-group mb-0">
                                                        <input className="form-control mb-1" type="text" value={stripeWebhookSecret} onChange={(e) => setStripeWebhookSecret(e.target.value)} />
                                                        { !stringHelpers.lengthValidation(stripeWebhookSecret, 150) && <small className='text-danger'>This field cannot exceed 150 characters.</small> }
                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                    </>}
                                </div>
                                {paymentProviderInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setPaymentProvider(settings.paymentProvider);
                                                        setStripePublishableKey(settings.stripePublishableKey);
                                                        setStripeSecretKey(settings.stripeSecretKey)
                                                        setStripeWebhookSecret(settings.stripeWebhookSecret)
                                                        setPaymentProviderInEdit(false)
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(stripePublishableKey, 150) || !stringHelpers.lengthValidation(stripeSecretKey, 150) || !stringHelpers.lengthValidation(stripeWebhookSecret, 150)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                            <div className="card mb-3" id="kadoe-settings">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">KADOE Settings</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (kadoeInEdit) {
                                                    setKadoeConnectionType(settings.kadoeConnectionType)
                                                    setKadoeApiKey(settings.kadoeApiKey);
                                                    setKadoeUsername(settings.kadoeUsername);
                                                    setKadoePassword(settings.kadoePassword);
                                                    setKadoeEnquirerId(settings.kadoeEnquirerId)
                                                }
                                                setKadoeInEdit(!kadoeInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!kadoeInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Connection Type</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{ Enums.KadoeConnectionType[kadoeConnectionType] }</div>
                                        </div>
                                        {
                                            kadoeConnectionType === 1 &&
                                            <>
                                                <div className="row">
                                                    <div className="col-md-3 col-12 ">
                                                        <p className="font-weight-semi-bold  mb-3">Username</p>
                                                    </div>
                                                    <div className="col-md-6 col-12 ">{kadoeUsername}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-12 ">
                                                        <p className="font-weight-semi-bold  mb-3">Password</p>
                                                    </div>
                                                    <div className="col-md-6 col-12 ">{kadoePassword}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-12 ">
                                                        <p className="font-weight-semi-bold  mb-3">API Key</p>
                                                    </div>
                                                    <div className="col-md-6 col-12 ">{kadoeApiKey}</div>
                                                </div>
                                            </>
                                        }
                                        {kadoeConnectionType > 0 && 
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Enquirer ID</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{kadoeEnquirerId}</div>
                                        </div>}
                                    </>}
                                    {kadoeInEdit && <>
                                        <div className="row mb-2">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Connection Type</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0 mt-1">
                                                    {
                                                        Object.entries(Enums.KadoeConnectionType)
                                                            .map(
                                                                ([connectionTypeKey, connectionTypeLabel]) =>
                                                                    <div key={connectionTypeKey} className='d-flex align-items-center mr-4'>
                                                                        <input onClick={ e => setKadoeConnectionType(Number(e.target.value)) } className='mb-1' name="kadoe-connection-type" id={`connection-type-${connectionTypeLabel}`} type='radio' value={ connectionTypeKey } checked={ kadoeConnectionType === Number(connectionTypeKey) } />
                                                                        <label style={ { fontSize: "1rem" } } className='m-0 ml-2' htmlFor={`connection-type-${connectionTypeLabel}`}>{ connectionTypeLabel }</label>
                                                                    </div>
                                                            )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        {kadoeConnectionType === 1 && <>
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold mb-1">Username</p>
                                                </div>
                                                <div className="col-md-6 col-12">
                                                    <div className="form-group mb-0">
                                                        <input className="form-control mb-1" type="text" value={ kadoeUsername } onChange={ (e) => setKadoeUsername(e.target.value) } />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold mb-1">Password</p>
                                                </div>
                                                <div className="col-md-6 col-12">
                                                    <div className="mb-0 input-group">
                                                        <input readOnly className="border rounded-left mb-1 form-control-plaintext px-3 bg-white" type="text" value={ kadoePassword } />
                                                        <div className="input-group-append">
                                                            <button data-toggle="modal" data-target="#kadoe-password" id="kadoe-password-modal" className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center" disabled={ !isGlobalAdmin }><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold mb-1">API Key</p>
                                                </div>
                                                <div className="col-md-6 col-12">
                                                    <div className="input-group mb-0">
                                                        <input readOnly className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ kadoeApiKey } />
                                                        <div className="input-group-append">
                                                            <button data-toggle="modal" data-target="#kadoe-api-key" id="kadoe-api-key-modal" className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center" disabled={ !isGlobalAdmin }><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                        {kadoeConnectionType > 0 && 
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Enquirer ID</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={kadoeEnquirerId} onChange={(e) => setKadoeEnquirerId(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>}
                                    </>}
                                    <div className="modal fade" id="kadoe-password" data-parent="#kadoe-password-modal" tabIndex="-1" role="dialog">
                                        <div className="modal-dialog" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Warning</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    This will generate a new Kadoe password. Are you sure?
                                                </div>
                                                <div className="modal-footer">
                                                    <button className="btn btn-sm btn-falcon-default" data-dismiss="modal">Close</button>
                                                    <button onClick={() => generateNewKadoePassword()} className="btn btn-sm btn-success" data-dismiss="modal">Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal fade" id="kadoe-api-key" data-parent="#kadoe-api-key-modal" tabIndex="-1" role="dialog">
                                        <div className="modal-dialog" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Warning</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    This will generate a new Kadoe API key. Are you sure?
                                                </div>
                                                <div className="modal-footer">
                                                    <button className="btn btn-sm btn-falcon-default" data-dismiss="modal">Close</button>
                                                    <button onClick={() => generateNewKadoeApiKey()} className="btn btn-sm btn-success" data-dismiss="modal">Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {kadoeInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setKadoeConnectionType(settings.kadoeConnectionType)
                                                        setKadoeApiKey(settings.kadoeApiKey);
                                                        setKadoeUsername(settings.kadoeUsername);
                                                        setKadoePassword(settings.kadoePassword);
                                                        setKadoeEnquirerId(settings.kadoeEnquirerId)
                                                        setKadoeInEdit(false);
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                            
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">Data Purging</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (dataPurgingInEdit) {
                                                    setPurgeNonPcnCameraDataMonths(settings.purgeNonPcnCameraDataMonths >=2 ? settings.purgeNonPcnCameraDataMonths : 6);
                                                    setAllowPurgeNonPcnCameraDataMonths(settings.purgeNonPcnCameraDataMonths >= 2)
                                                }
                                                setDataPurgingInEdit(!dataPurgingInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!dataPurgingInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Automatically purge non-PCN camera data</p>
                                            </div>
                                            <div className="col-md-6 col-12 d-flex">
                                                {allowPurgeNonPcnCameraDataMonths ? <p>{purgeNonPcnCameraDataMonths} month{purgeNonPcnCameraDataMonths === 1 ? "" : "s"}</p> : <i className="mt-1 fas fa-times text-danger"></i>}
                                            </div>
                                        </div>
                                    </>}
                                    {dataPurgingInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Automatically purge non-PCN camera data</p>
                                            </div>
                                            <div className="col-md-6 col-12 d-flex align-items-start">
                                                <div className='custom-control custom-switch'>
                                                    <input className="custom-control-input" type="checkbox" id="switch1" checked={allowPurgeNonPcnCameraDataMonths} onChange={() => setAllowPurgeNonPcnCameraDataMonths(!allowPurgeNonPcnCameraDataMonths)} />
                                                    <label className="custom-control-label custom-toggle" htmlFor="switch1"></label>
                                                </div>
                                                {
                                                    allowPurgeNonPcnCameraDataMonths && 
                                                    <div className="form-group mb-0 ml-4 d-flex gap-2 align-items-center">
                                                        <input class="form-range" type="range" min="1" max="12" value={purgeNonPcnCameraDataMonths} onChange={(e) => setPurgeNonPcnCameraDataMonths(Number(e.target.value))} />
                                                        <p className='m-0 ml-2'>{purgeNonPcnCameraDataMonths} month{purgeNonPcnCameraDataMonths === 1 ? "" : "s"}</p>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                {dataPurgingInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setPurgeNonPcnCameraDataMonths(settings.purgeNonPcnCameraDataMonths >=1 ? settings.purgeNonPcnCameraDataMonths : 6);
                                                        setAllowPurgeNonPcnCameraDataMonths(settings.purgeNonPcnCameraDataMonths >= 1)
                                                        setDataPurgingInEdit(false);
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                            <div className="card mb-3" id="cashless-providers-settings">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">Parkonomy Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(1)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (parkonomyInEdit) {
                                                    setParkonomyApiKey(settings.parkonomyApiKey)
                                                }
                                                setParkonomyInEdit(!parkonomyInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!parkonomyInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Parkonomy API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{parkonomyApiKey}</div>
                                        </div>
                                    </>}
                                    {parkonomyInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Parkonomy API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setParkonomyApiKey(e.target.value)} className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ parkonomyApiKey } />
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "Parkonomy API key",
                                                                onConfirm: () => {
                                                                    setParkonomyApiKey(stringHelpers.generateRandomString());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    { !stringHelpers.lengthValidation(parkonomyApiKey, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/parkonomy</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/parkonomy/slot`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {parkonomyInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setParkonomyApiKey(settings.parkonomyApiKey)
                                                        setParkonomyInEdit(false);
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(parkonomyApiKey, 50)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">RingGo Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(2)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (ringGoInEdit) {
                                                    setRingGoApiPrivateKey(settings.ringGoApiPrivateKey);
                                                    setRingGoApiPublicKey(settings.ringGoApiPublicKey);
                                                }
                                                setRingGoInEdit(!ringGoInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">RingGo API Private Key</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            {!ringGoInEdit &&                             
                                                <>{ringGoApiPrivateKey}</>
                                            }
                                            {ringGoInEdit &&
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ringGoApiPrivateKey} onChange={(e) => setRingGoApiPrivateKey(e.target.value)} />
                                                    { !stringHelpers.isValidBase64(ringGoApiPrivateKey) && <small className='text-danger'>This field needs to be a valid Base64 string.</small> }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">RingGo API Public Key</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            {!ringGoInEdit &&                             
                                                <>{ringGoApiPublicKey}</>
                                            }
                                            {ringGoInEdit &&
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ringGoApiPublicKey} onChange={(e) => setRingGoApiPublicKey(e.target.value)} />
                                                    { !stringHelpers.lengthValidation(ringGoApiPublicKey, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/ringgo</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/ringgo/sessions`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {ringGoInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setRingGoApiPrivateKey(settings.ringGoApiPrivateKey);
                                                        setRingGoApiPublicKey(settings.ringGoApiPublicKey);
                                                        setRingGoInEdit(false)
                                                        }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(ringGoApiPublicKey, 50) || !stringHelpers.isValidBase64(ringGoApiPrivateKey)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                            
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">JustPark Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(4)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (justParkInEdit) {
                                                    setJustParkApiKey(settings.justParkApiKey);
                                                }
                                                setJustParkInEdit(!justParkInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!justParkInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">JustPark API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{justParkApiKey}</div>
                                        </div>
                                    </>}
                                    {justParkInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">JustPark API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setJustParkApiKey(e.target.value)} className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ justParkApiKey } />
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "JustPark API key",
                                                                onConfirm: () => {
                                                                    setJustParkApiKey(stringHelpers.generateRandomString());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    { !stringHelpers.lengthValidation(justParkApiKey, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/justpark</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/justpark`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {justParkInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setJustParkApiKey(settings.justParkApiKey);
                                                        setJustParkInEdit(false)
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(justParkApiKey, 50)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">Tap2Park Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(5)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (tap2ParkInEdit) {
                                                    setTap2ParkApiKey(settings.tap2ParkApiKey);
                                                }
                                                setTap2ParkInEdit(!tap2ParkInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!tap2ParkInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Tap2Park API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{tap2ParkApiKey}</div>
                                        </div>
                                        
                                    </>}
                                    {tap2ParkInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Tap2Park API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setTap2ParkApiKey(e.target.value)} className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ tap2ParkApiKey } />
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "Tap2Park API key",
                                                                onConfirm: () => {
                                                                    setTap2ParkApiKey(stringHelpers.generateRandomString());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    { !stringHelpers.lengthValidation(tap2ParkApiKey, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/tap2park</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/tap2park`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {tap2ParkInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setTap2ParkApiKey(settings.tap2ParkApiKey);
                                                        setTap2ParkInEdit(false);
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(tap2ParkApiKey, 50)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">PayByPhone Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(6)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (payByPhoneInEdit) {
                                                    setPayByPhoneUsername(settings.payByPhoneUsername);
                                                    setPayByPhonePassword(settings.payByPhonePassword);
                                                }
                                                setPayByPhoneInEdit(!payByPhoneInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!payByPhoneInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">PayByPhone Username</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{payByPhoneUsername}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">PayByPhone Password</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{payByPhonePassword}</div>
                                        </div>
                                    </>}
                                    {payByPhoneInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">PayByPhone Username</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setPayByPhoneUsername(e.target.value)} className={ `border ${ showPayByPhoneUsernameGenerateButton ? "rounded-left" : "rounded" } form-control mb-1 form-control-plaintext px-3 bg-white` } type="text" value={ payByPhoneUsername } />
                                                    {
                                                        showPayByPhoneUsernameGenerateButton &&
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "PayByPhone username",
                                                                onConfirm: () => {
                                                                    setPayByPhoneUsername(props.organisationName.replace(/\s+/g, "").toLowerCase());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">PayByPhone Password</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setPayByPhonePassword(e.target.value)} className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ payByPhonePassword } />
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "PayByPhone password",
                                                                onConfirm: () => {
                                                                    setPayByPhonePassword(stringHelpers.generateRandomString());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/paybyphone</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/paybyphone`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {payByPhoneInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setPayByPhoneUsername(settings.payByPhoneUsername);
                                                        setPayByPhonePassword(settings.payByPhonePassword);
                                                        setPayByPhoneInEdit(false);
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                            
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">ParkBunny Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(7)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (parkbunnyInEdit) {
                                                    setParkbunnyApiKey(settings.parkBunnyApiKey); 
                                                }
                                                setParkbunnyInEdit(!parkbunnyInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!parkbunnyInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">ParkBunny API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">{parkbunnyApiKey}</div>
                                        </div>
                                    </>}
                                    {parkbunnyInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">ParkBunny API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setParkbunnyApiKey(e.target.value)} className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ parkbunnyApiKey } />
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "ParkBunny API key",
                                                                onConfirm: () => {
                                                                    setParkbunnyApiKey(stringHelpers.generateRandomString());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    { !stringHelpers.lengthValidation(parkbunnyApiKey, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/parkbunny</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/parkbunny`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {parkbunnyInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setParkbunnyApiKey(settings.parkBunnyApiKey); 
                                                        setParkbunnyInEdit(false)
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(parkbunnyApiKey, 50)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">IPS Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(8)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (ipsInEdit) {
                                                    setIpsApiKey(settings.ipsApiKey); 
                                                }
                                                setIpsInEdit(!ipsInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!ipsInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">IPS API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">{ipsApiKey}</div>
                                        </div>
                                    </>}
                                    {ipsInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">IPS API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setIpsApiKey(e.target.value)} className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ ipsApiKey } />
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "IPS API key",
                                                                onConfirm: () => {
                                                                    setIpsApiKey(stringHelpers.generateRandomString());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/ips</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/ips`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {ipsInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setIpsApiKey(settings.ipsApiKey); 
                                                        setIpsInEdit(false)
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(ipsApiKey, 50)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">Convious Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(9)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (conviousInEdit) {
                                                    setConviousApiKey(settings.conviousApiKey)
                                                }
                                                setConviousInEdit(!conviousInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!conviousInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Convious API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{conviousApiKey}</div>
                                        </div>
                                    </>}
                                    {conviousInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Convious API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setConviousApiKey(e.target.value)} className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ conviousApiKey } />
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "Convious API key",
                                                                onConfirm: () => {
                                                                    setConviousApiKey(stringHelpers.generateRandomString());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    { !stringHelpers.lengthValidation(conviousApiKey, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/convious</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/convious`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {conviousInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setConviousApiKey(settings.conviousApiKey)
                                                        setConviousInEdit(false);
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(conviousApiKey, 50)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">LookingForCarPark Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(10)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (lookingForCarParkInEdit) {
                                                    setLookingForCarParkApiKey(settings.lookingForCarParkApiKey)
                                                }
                                                setLookingForCarParkInEdit(!lookingForCarParkInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!lookingForCarParkInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">LookingForCarPark API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{lookingForCarParkApiKey}</div>
                                        </div>
                                    </>}
                                    {lookingForCarParkInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">LookingForCarPark API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setLookingForCarParkApiKey(e.target.value)} className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ lookingForCarParkApiKey } />
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "LookingForCarPark API key",
                                                                onConfirm: () => {
                                                                    setLookingForCarParkApiKey(stringHelpers.generateRandomString());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    { !stringHelpers.lengthValidation(lookingForCarParkApiKey, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/lookingforcarpark</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/lookingforcarpark`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {lookingForCarParkInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setLookingForCarParkApiKey(settings.lookingForCarParkApiKey)
                                                        setLookingForCarParkInEdit(false);
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(lookingForCarParkApiKey, 50)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">NewPark Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(11)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (newParkInEdit) {
                                                    setNewParkApiKey(settings.newParkApiKey)
                                                }
                                                setNewParkInEdit(!newParkInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!newParkInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">NewPark API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{newParkApiKey}</div>
                                        </div>
                                    </>}
                                    {newParkInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">NewPark API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setNewParkApiKey(e.target.value)} className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ newParkApiKey } />
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "NewPark API key",
                                                                onConfirm: () => {
                                                                    setNewParkApiKey(stringHelpers.generateRandomString());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    { !stringHelpers.lengthValidation(newParkApiKey, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/newpark</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/newpark`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {newParkInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setNewParkApiKey(settings.newParkApiKey)
                                                        setNewParkInEdit(false);
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(newParkApiKey, 50)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">Parkso Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(12)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (parksoInEdit) {
                                                    setParksoApiKey(settings.parksoApiKey)
                                                }
                                                setParksoInEdit(!parksoInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!parksoInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Parkso API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{parksoApiKey}</div>
                                        </div>
                                    </>}
                                    {parksoInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Parkso API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setParksoApiKey(e.target.value)} className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ parksoApiKey } />
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "Parkso API key",
                                                                onConfirm: () => {
                                                                    setParksoApiKey(stringHelpers.generateRandomString());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    { !stringHelpers.lengthValidation(parksoApiKey, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/parkso</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/parkso`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {parksoInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setParksoApiKey(settings.parksoApiKey)
                                                        setParksoInEdit(false);
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(parksoApiKey, 50)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">My Car Pass Settings</h5>
                                            <div className="logo-container">{imageUtilities.fetchPaymentProviderLogo(13)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (myCarPassInEdit) {
                                                    setMyCarPassApiKey(settings.myCarPassApiKey);
                                                }
                                                setMyCarPassInEdit(!myCarPassInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!myCarPassInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">My Car Pass API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">{myCarPassApiKey}</div>
                                        </div>
                                    </>}
                                    {myCarPassInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">My Car Pass API Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <input onChange={(e) => setMyCarPassApiKey(e.target.value)} className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ myCarPassApiKey } />
                                                        <div className="input-group-append">
                                                            <button type='button' onClick={() => setRandomStringGenerationConfig({
                                                                title: "My Car Pass API key",
                                                                onConfirm: () => {
                                                                    setMyCarPassApiKey(stringHelpers.generateRandomString());
                                                                    setRandomStringGenerationConfig(null);
                                                                }
                                                            })} className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center"><i className='fas fa-undo'></i></button>
                                                        </div>
                                                    { !stringHelpers.lengthValidation(myCarPassApiKey, 50) && <small className='text-danger'>This field cannot exceed 50 characters.</small> }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mb-3">Webhook URL</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <span className="text-break">{webhookApiBase}/mycarpass</span>
                                            <button className="btn btn-sm p-0 ml-2" title="Copy webhook URL" onClick={() => navigator.clipboard.writeText(`${webhookApiBase}/mycarpass`)}>
                                                <i className="fas fa-copy" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {myCarPassInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setMyCarPassApiKey(settings.myCarPassApiKey);
                                                        setMyCarPassInEdit(false)
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={!stringHelpers.lengthValidation(myCarPassApiKey, 50)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">IPC Data Export</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (ipcInEdit) {
                                                    setIpcDataExportEnabled(settings.ipcDataExportEnabled);
                                                    setIpcDataExportHostName(settings.ipcDataExportHostName);
                                                    setIpcDataExportUsername(settings.ipcDataExportUsername);
                                                    setIpcDataExportPassword(settings.ipcDataExportPassword);
                                                    setIpcDataExportBucket(settings.ipcDataExportBucket);
                                                    setIpcDataExportEncryptionKey(settings.ipcDataExportEncryptionKey);
                                                    setIpcDataExportStaticIv(settings.ipcDataExportStaticIv);
                                                }
                                                setIpcInEdit(!ipcInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container" id="ipc-data-export-settings">
                                    {!ipcInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Enabled</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                {ipcDataExportEnabled && <i className="fas fa-check text-success"></i>}{!ipcDataExportEnabled && <i className="fas fa-times text-danger"></i>}
                                            </div>                                            
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Hostname</p>
                                            </div>
                                            <div className="col-md-6 col-12">{ipcDataExportHostName}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Username</p>
                                            </div>
                                            <div className="col-md-6 col-12">{ipcDataExportUsername}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Password</p>
                                            </div>
                                            <div className="col-md-6 col-12">{ipcDataExportPassword}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Bucket</p>
                                            </div>
                                            <div className="col-md-6 col-12">{ipcDataExportBucket}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Encryption Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">{ipcDataExportEncryptionKey}</div>
                                            { !stringHelpers.lengthValidation(ipcDataExportEncryptionKey, 32) && <small className='text-danger'>This field cannot exceed 32 characters.</small> }
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Static IV</p>
                                            </div>
                                            <div className="col-md-6 col-12">{ipcDataExportStaticIv}</div>
                                            { !stringHelpers.lengthValidation(ipcDataExportStaticIv, 16) && <small className='text-danger'>This field cannot exceed 16 characters.</small> }
                                        </div>
                                    </>}
                                    {ipcInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Enabled</p>
                                            </div>
                                            <div className=" col-md-6 col-12 custom-control custom-switch">
                                                <input className="custom-control-input" type="checkbox" id="ipc-data-export-enabled" checked={ipcDataExportEnabled} onChange={() => setIpcDataExportEnabled(!ipcDataExportEnabled)} />
                                                <label className="custom-control-label custom-toggle ml-3" htmlFor="ipc-data-export-enabled"></label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Hostname</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ipcDataExportHostName} onChange={(e) => setIpcDataExportHostName(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Username</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ipcDataExportUsername} onChange={(e) => setIpcDataExportUsername(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Password</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ipcDataExportPassword} onChange={(e) => setIpcDataExportPassword(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Bucket</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ipcDataExportBucket} onChange={(e) => setIpcDataExportBucket(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Encryption Key</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ipcDataExportEncryptionKey} onChange={(e) => setIpcDataExportEncryptionKey(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Static IV</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ipcDataExportStaticIv} onChange={(e) => setIpcDataExportStaticIv(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                {ipcInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setIpcDataExportEnabled(settings.ipcDataExportEnabled);
                                                        setIpcDataExportHostName(settings.ipcDataExportHostName);
                                                        setIpcDataExportUsername(settings.ipcDataExportUsername);
                                                        setIpcDataExportPassword(settings.ipcDataExportPassword);
                                                        setIpcDataExportBucket(settings.ipcDataExportBucket);
                                                        setIpcDataExportEncryptionKey(settings.ipcDataExportEncryptionKey);
                                                        setIpcDataExportStaticIv(settings.ipcDataExportStaticIv);
                                                        setIpcInEdit(false);
                                                        }}>
                                                        <i className="fas fa-times"></i> Cancel
                                                    </button>
                                                    <button disabled={!stringHelpers.lengthValidation(ipcDataExportEncryptionKey, 32) && !stringHelpers.lengthValidation(ipcDataExportStaticIv, 16)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">FTP</h5>
                                        </div>
                                        {isGlobalAdmin && <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (ftpInEdit) {
                                                    setFtpUsername(settings.ftpUsername);
                                                    setFtpPassword(settings.ftpPassword);
                                                }
                                                setFtpInEdit(!ftpInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>}
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!ftpInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Username</p>
                                            </div>
                                            <div className="col-md-6 col-12">{ftpUsername}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Password</p>
                                            </div>
                                            <div className="col-md-6 col-12">{ftpPassword}</div>
                                        </div>
                                    </>}
                                    {ftpInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Username</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ftpUsername} onChange={(e) => setFtpUsername(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Password</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={ftpPassword} onChange={(e) => setFtpPassword(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                {ftpInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setFtpUsername(settings.ftpUsername);
                                                        setFtpPassword(settings.ftpPassword);
                                                        setFtpInEdit(false);
                                                        }}>
                                                        <i className="fas fa-times"></i> Cancel
                                                    </button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">Debt Recovery</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (debtRecoveryInEdit) {
                                                    setReadyForDebtRecoveryDays(settings.readyForDebtRecoveryDays)
                                                }
                                                setDebtRecoveryInEdit(!debtRecoveryInEdit)}
                                                }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!debtRecoveryInEdit &&
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Ready for debt recovery days</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{readyForDebtRecoveryDays}</div>
                                        </div>
                                    }
                                     {debtRecoveryInEdit &&
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Ready for debt recovery days</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="number" value={readyForDebtRecoveryDays} onChange={(e) => setReadyForDebtRecoveryDays(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                {debtRecoveryInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => {
                                                        setReadyForDebtRecoveryDays(settings.readyForDebtRecoveryDays)
                                                        setDebtRecoveryInEdit(false)
                                                    } }>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">Transfer 360</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (transfer360InEdit) {
                                                    setEnableTransfer360(settings.enableTransfer360)
                                                }
                                                setTransfer360InEdit(!transfer360InEdit)}
                                                }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!transfer360InEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Enabled</p>
                                            </div>
                                            <div className="col-md-6 col-12 pt-1">
                                                {enableTransfer360 && <i className="fas fa-check text-success"></i>}{!enableTransfer360 && <i className="fas fa-times text-danger"></i>}
                                            </div>
                                        </div>
                                    </>}
                                    {transfer360InEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Enabled</p>
                                            </div>
                                            <div className=" col-md-6 col-12 custom-control custom-switch">
                                                <input className="custom-control-input" type="checkbox" id="transfer-360-look-up" checked={enableTransfer360} onChange={() => setEnableTransfer360(!enableTransfer360)} />
                                                <label className="custom-control-label custom-toggle ml-3" htmlFor="transfer-360-look-up"></label>
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                {
                                    transfer360InEdit &&
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setEnableTransfer360(settings.enableTransfer360);
                                                        setTransfer360InEdit(false)
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            
                            <div className="card mb-3">
                                <div className="card-header" id="email-settings">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">Email Settings</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (emailSettingsInEdit) {
                                                    setEmailsEnabled(settings.emailsEnabled);
                                                    setEmailSenderName(settings.emailSenderName);
                                                    setEmailSenderAddress(settings.emailSenderAddress);
                                                    setAppealReceivedSubject(settings.appealReceivedSubject);
                                                    setAppealReceivedContent(settings.appealReceivedContent);
                                                    setTransferOfLiabilityReceivedSubject(settings.transferOfLiabilityReceivedSubject);
                                                    setTransferOfLiabilityReceivedContent(settings.transferOfLiabilityReceivedContent);
                                                    setAppealAcceptedResponseSubject(settings.appealAcceptedResponseSubject)
                                                    setAppealAcceptedResponseStatus(settings.appealAcceptedResponseStatus ?? "")
                                                    setAppealAcceptedResponseContent(settings.appealAcceptedResponseContent)
                                                    setAppealDeclinedResponseSubject(settings.appealDeclinedResponseSubject)
                                                    setAppealDeclinedResponseStatus(settings.appealDeclinedResponseStatus ?? "")
                                                    setAppealDeclinedResponseContent(settings.appealDeclinedResponseContent)
                                                    setAppealAcceptedResponseResetDateIssued(settings.appealAcceptedResponseResetDateIssued)
                                                    setAppealAcceptedResponseResetCharges(settings.appealAcceptedResponseResetCharges)
                                                    setAppealAcceptedResponseAdditionalCharge(settings.appealAcceptedResponseAdditionalCharge)
                                                    setAppealAcceptedResponseAdditionalChargeType(settings.appealAcceptedResponseAdditionalChargeType)
                                                    setAppealAcceptedResponseDebtRecoveryCharge(settings.appealAcceptedResponseDebtRecoveryCharge)
                                                    setAppealAcceptedResponseDebtRecoveryChargeType(settings.appealAcceptedResponseDebtRecoveryChargeType)
                                                    setAppealDeclinedResponseResetDateIssued(settings.appealDeclinedResponseResetDateIssued)
                                                    setAppealDeclinedResponseResetCharges(settings.appealDeclinedResponseResetCharges)
                                                    setAppealDeclinedResponseAdditionalCharge(settings.appealDeclinedResponseAdditionalCharge)
                                                    setAppealDeclinedResponseAdditionalChargeType(settings.appealDeclinedResponseAdditionalChargeType)
                                                    setAppealDeclinedResponseDebtRecoveryCharge(settings.appealDeclinedResponseDebtRecoveryCharge)
                                                    setAppealDeclinedResponseDebtRecoveryChargeType(settings.appealDeclinedResponseDebtRecoveryChargeType)
                                                }
                                                setEmailSettingsInEdit(!emailSettingsInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!emailSettingsInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Emails Enabled</p>
                                            </div>
                                            <div className="col-md-6 col-12 py-1">
                                                {emailsEnabled && <i className="fas fa-check text-success"></i>}{!emailsEnabled && <i className="fas fa-times text-danger"></i>}
                                            </div>                                            
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Sender Name</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{emailSenderName}</p>
                                            </div>                                            
                                        </div>
                                        <div className="row mb-1">
                                            <div className="col-md-3 col-12">
                                                <p className="font-weight-semi-bold">Sender Address</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{emailSenderAddress}</p>
                                            </div>                                            
                                        </div>
                                        <hr className="border-dashed border-bottom-0 mt-2"></hr>
                                        <h5 className="mb-3">Appeal Received</h5>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Subject</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{appealReceivedSubject}</p>
                                            </div>                                            
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Content</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p className='text-pre-wrap'>{appealReceivedContent}</p>
                                            </div>                                            
                                        </div>
                                        <hr className="border-dashed border-bottom-0 mt-0"></hr>
                                        <h5 className="mb-3">Appeal Accepted</h5>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Subject</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{appealAcceptedResponseSubject}</p>
                                            </div>                                            
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 mb-3">
                                                <p className="font-weight-semi-bold m-0">Breach Status</p>
                                                <small>Select the status to set the breach to after the appeal accepted email has been sent</small>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{Enums.BreachStatus[appealAcceptedResponseStatus]}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Reset Date Issued</p>
                                            </div>
                                            <div className="col-md-6 col-12 py-1">
                                                {appealAcceptedResponseResetDateIssued && <i className="fas fa-check text-success"></i>}{!appealAcceptedResponseResetDateIssued && <i className="fas fa-times text-danger"></i>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Reset Charges</p>
                                            </div>
                                            <div className="col-md-6 col-12 py-1">
                                                {appealAcceptedResponseResetCharges && <i className="fas fa-check text-success"></i>}{!appealAcceptedResponseResetCharges && <i className="fas fa-times text-danger"></i>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Debt Recovery Charge</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{formatCharge(appealAcceptedResponseDebtRecoveryCharge, appealAcceptedResponseDebtRecoveryChargeType)}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Additional Charge</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{formatCharge(appealAcceptedResponseAdditionalCharge, appealAcceptedResponseAdditionalChargeType)}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Content</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p className='text-pre-wrap'>{appealAcceptedResponseContent}</p>
                                            </div>                                            
                                        </div>
                                        <hr className="border-dashed border-bottom-0 mt-0"></hr>
                                        <h5 className="mb-3">Appeal Declined</h5>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Subject</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{appealDeclinedResponseSubject}</p>
                                            </div>                                            
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 mb-3">
                                                <p className="font-weight-semi-bold m-0">Breach Status</p>
                                                <small>Select the status to set the breach to after the appeal rejected email has been sent</small>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{Enums.BreachStatus[appealDeclinedResponseStatus]}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Reset Date Issued</p>
                                            </div>
                                            <div className="col-md-6 col-12 py-1">
                                                {appealDeclinedResponseResetDateIssued && <i className="fas fa-check text-success"></i>}{!appealDeclinedResponseResetDateIssued && <i className="fas fa-times text-danger"></i>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Reset Charges</p>
                                            </div>
                                            <div className="col-md-6 col-12 py-1">
                                                {appealDeclinedResponseResetCharges && <i className="fas fa-check text-success"></i>}{!appealDeclinedResponseResetCharges && <i className="fas fa-times text-danger"></i>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Debt Recovery Charge</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{formatCharge(appealDeclinedResponseDebtRecoveryCharge, appealDeclinedResponseDebtRecoveryChargeType)}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Additional Charge</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{formatCharge(appealDeclinedResponseAdditionalCharge, appealDeclinedResponseAdditionalChargeType)}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Content</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p className='text-pre-wrap'>{appealDeclinedResponseContent}</p>
                                            </div>                                            
                                        </div>
                                        <hr className="border-dashed border-bottom-0 mt-0"></hr>
                                        <h5 className="mb-3 mt-1">Transfer Of Liability Received</h5>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Subject</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p>{transferOfLiabilityReceivedSubject}</p>
                                            </div>                                            
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-3">Content</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <p className='text-pre-wrap'>{transferOfLiabilityReceivedContent}</p>
                                            </div>                                            
                                        </div>
                                    </>}
                                    {emailSettingsInEdit && <>
                                        <div className="row mb-2">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Emails Enabled</p>
                                            </div>
                                            <div className=" col-md-6 col-12 custom-control custom-switch">
                                                <input className="custom-control-input" type="checkbox" id="emails-enabled" checked={emailsEnabled} onChange={() => setEmailsEnabled(!emailsEnabled)} />
                                                <label className="custom-control-label custom-toggle ml-3" htmlFor="emails-enabled"></label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Sender Name</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={emailSenderName} onChange={(e) => setEmailSenderName(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Sender Address</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={emailSenderAddress} onChange={(e) => setEmailSenderAddress(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="border-dashed border-bottom-0 mt-0"></hr>
                                        <h5 className="mb-2 mt-1">Appeal Received</h5>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Subject</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={appealReceivedSubject} onChange={(e) => setAppealReceivedSubject(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-1">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Content</p>
                                                <small>Write your email content here. Click any placeholder below to insert dynamic content at your cursor position. It will be replaced with real data when the email is sent.</small>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <textarea ref={appealReceivedContentInputRef} rows={6} className="form-control mb-1" type="text" value={appealReceivedContent} onChange={(e) => setAppealReceivedContent(e.target.value)} />
                                                </div>
                                                <div>
                                                    {
                                                        !arrayUtilities.isNullOrEmpty(placeholders) &&
                                                        placeholders.map(
                                                            placeholder => <button className="btn btn-falcon-default btn-xs m-1" onClick={() => stringHelpers.insertTextAtCursorPosition(placeholder.formattedName, appealReceivedContentInputRef, setAppealReceivedContent)}>{placeholder.description}</button>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="border-dashed border-bottom-0 mt-0"></hr>
                                        <h5 className="mb-2 mt-1">Appeal Accepted</h5>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Subject</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={appealAcceptedResponseSubject} onChange={(e) => setAppealAcceptedResponseSubject(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-1">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Status</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <SearchSelect
                                                    width="100%"
                                                    options={
                                                        [ {value: "", label: "None"}, ...Object.entries(Enums.BreachStatus).map(([key,value]) => ({ value:key, label:value }))]
                                                    }
                                                    onSelect={value => {
                                                        if (stringHelpers.isNullOrEmpty(value)) {
                                                            setAppealAcceptedResponseStatus("")
                                                        }
                                                        else {
                                                            setAppealAcceptedResponseStatus(Number(value))
                                                        }
                                                    }}
                                                    selected={String(appealAcceptedResponseStatus)}
                                                    defaultLabel='None'
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Reset Date Issued</p>
                                            </div>
                                            <div className=" col-md-6 col-12 custom-control custom-switch">
                                                <input className="custom-control-input" type="checkbox" id="appeal-accepted-response-reset-date-issued" checked={appealAcceptedResponseResetDateIssued} onChange={() => setAppealAcceptedResponseResetDateIssued(!appealAcceptedResponseResetDateIssued)} />
                                                <label className="custom-control-label custom-toggle ml-3" htmlFor="appeal-accepted-response-reset-date-issued"></label>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Reset Charges</p>
                                            </div>
                                            <div className=" col-md-6 col-12 custom-control custom-switch">
                                                <input className="custom-control-input" type="checkbox" id="appeal-accepted-response-reset-charges" checked={appealAcceptedResponseResetCharges} onChange={() => setAppealAcceptedResponseResetCharges(!appealAcceptedResponseResetCharges)} />
                                                <label className="custom-control-label custom-toggle ml-3" htmlFor="appeal-accepted-response-reset-charges"></label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Debt Recovery Charge</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <div className="input-group-prepend">
                                                        <button className="btn btn-falcon-default dropdown-toggle edit-dropdown ws-normal shadow-none border" id="select-appeal-accepted-response-debt-recovery-charge-type" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{Enums.ChargeType[appealAcceptedResponseDebtRecoveryChargeType]}</button>
                                                        <div className="dropdown-menu py-0 edit-dropdown" aria-labelledby="select-appeal-accepted-response-debt-recovery-charge-type">
                                                            <div className="bg-white py-3 rounded-soft">
                                                                {Object.entries(Enums.ChargeType).map(([key, value]) =>
                                                                    <button key={key} type="button" className="dropdown-item text-base px-3 py-2" onClick={() => setAppealAcceptedResponseDebtRecoveryChargeType(Number(key))}>{value}</button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <input className="form-control" type="number" step="0.01" value={appealAcceptedResponseDebtRecoveryCharge} onChange={(e) => setAppealAcceptedResponseDebtRecoveryCharge(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-1">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Additional Charge</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <div className="input-group-prepend">
                                                        <button className="btn btn-falcon-default dropdown-toggle edit-dropdown ws-normal shadow-none border" id="select-appeal-accepted-response-additional-charge-type" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{Enums.ChargeType[appealAcceptedResponseAdditionalChargeType]}</button>
                                                        <div className="dropdown-menu py-0 edit-dropdown" aria-labelledby="select-appeal-accepted-response-additional-charge-type">
                                                            <div className="bg-white py-3 rounded-soft">
                                                                {Object.entries(Enums.ChargeType).map(([key, value]) =>
                                                                    <button key={key} type="button" className="dropdown-item text-base px-3 py-2" onClick={() => setAppealAcceptedResponseAdditionalChargeType(Number(key))}>{value}</button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <input className="form-control" type="number" step="0.01" value={appealAcceptedResponseAdditionalCharge} onChange={(e) => setAppealAcceptedResponseAdditionalCharge(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Content</p>
                                                <small>Write your email content here. Click any placeholder below to insert dynamic content at your cursor position. It will be replaced with real data when the email is sent.</small>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <textarea ref={appealAcceptedContentInputRef}  rows={6} className="form-control mb-1" type="text" value={appealAcceptedResponseContent} onChange={(e) => setAppealAcceptedResponseContent(e.target.value)} />
                                                </div>
                                                <div>
                                                    {
                                                        !arrayUtilities.isNullOrEmpty(placeholders) &&
                                                        placeholders.map(
                                                            placeholder => <button className="btn btn-falcon-default btn-xs m-1" onClick={() => stringHelpers.insertTextAtCursorPosition(placeholder.formattedName, appealAcceptedContentInputRef, setAppealAcceptedResponseContent)}>{placeholder.description}</button>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <hr className="border-dashed border-bottom-0 mt-0"></hr>
                                        <h5 className="mb-2 mt-1">Appeal Declined</h5>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Subject</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={appealDeclinedResponseSubject} onChange={(e) => setAppealDeclinedResponseSubject(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-1">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Status</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <SearchSelect
                                                    width="100%"
                                                    options={
                                                        [ {value: "", label: "None"}, ...Object.entries(Enums.BreachStatus).map(([key,value]) => ({ value:key, label:value }))]
                                                    }
                                                    onSelect={value => {
                                                        if (stringHelpers.isNullOrEmpty(value)) {
                                                            setAppealDeclinedResponseStatus("")
                                                        }
                                                        else {
                                                            setAppealDeclinedResponseStatus(Number(value))
                                                        }
                                                    }}
                                                    selected={String(appealDeclinedResponseStatus)}
                                                    defaultLabel='None'
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Reset Date Issued</p>
                                            </div>
                                            <div className=" col-md-6 col-12 custom-control custom-switch">
                                                <input className="custom-control-input" type="checkbox" id="appeal-declined-response-reset-date-issued" checked={appealDeclinedResponseResetDateIssued} onChange={() => setAppealDeclinedResponseResetDateIssued(!appealDeclinedResponseResetDateIssued)} />
                                                <label className="custom-control-label custom-toggle ml-3" htmlFor="appeal-declined-response-reset-date-issued"></label>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Reset Charges</p>
                                            </div>
                                            <div className=" col-md-6 col-12 custom-control custom-switch">
                                                <input className="custom-control-input" type="checkbox" id="appeal-declined-response-reset-charges" checked={appealDeclinedResponseResetCharges} onChange={() => setAppealDeclinedResponseResetCharges(!appealDeclinedResponseResetCharges)} />
                                                <label className="custom-control-label custom-toggle ml-3" htmlFor="appeal-declined-response-reset-charges"></label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Debt Recovery Charge</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <div className="input-group-prepend">
                                                        <button className="btn btn-falcon-default dropdown-toggle edit-dropdown ws-normal shadow-none border" id="select-appeal-declined-response-debt-recovery-charge-type" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{Enums.ChargeType[appealDeclinedResponseDebtRecoveryChargeType]}</button>
                                                        <div className="dropdown-menu py-0 edit-dropdown" aria-labelledby="select-appeal-declined-response-debt-recovery-charge-type">
                                                            <div className="bg-white py-3 rounded-soft">
                                                                {Object.entries(Enums.ChargeType).map(([key, value]) =>
                                                                    <button key={key} type="button" className="dropdown-item text-base px-3 py-2" onClick={() => setAppealDeclinedResponseDebtRecoveryChargeType(Number(key))}>{value}</button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <input className="form-control" type="number" step="0.01" value={appealDeclinedResponseDebtRecoveryCharge} onChange={(e) => setAppealDeclinedResponseDebtRecoveryCharge(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-1">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Additional Charge</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="input-group mb-1">
                                                    <div className="input-group-prepend">
                                                        <button className="btn btn-falcon-default dropdown-toggle edit-dropdown ws-normal shadow-none border" id="select-appeal-declined-response-additional-charge-type" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{Enums.ChargeType[appealDeclinedResponseAdditionalChargeType]}</button>
                                                        <div className="dropdown-menu py-0 edit-dropdown" aria-labelledby="select-appeal-declined-response-additional-charge-type">
                                                            <div className="bg-white py-3 rounded-soft">
                                                                {Object.entries(Enums.ChargeType).map(([key, value]) =>
                                                                    <button key={key} type="button" className="dropdown-item text-base px-3 py-2" onClick={() => setAppealDeclinedResponseAdditionalChargeType(Number(key))}>{value}</button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <input className="form-control" type="number" step="0.01" value={appealDeclinedResponseAdditionalCharge} onChange={(e) => setAppealDeclinedResponseAdditionalCharge(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Content</p>
                                                <small>Write your email content here. Click any placeholder below to insert dynamic content at your cursor position. It will be replaced with real data when the email is sent.</small>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <textarea ref={appealDeclinedContentInputRef}  rows={6} className="form-control mb-1" type="text" value={appealDeclinedResponseContent} onChange={(e) => setAppealDeclinedResponseContent(e.target.value)} />
                                                </div>
                                                <div>
                                                    {
                                                        !arrayUtilities.isNullOrEmpty(placeholders) &&
                                                        placeholders.map(
                                                            placeholder => <button className="btn btn-falcon-default btn-xs m-1" onClick={() => stringHelpers.insertTextAtCursorPosition(placeholder.formattedName, appealDeclinedContentInputRef, setAppealDeclinedResponseContent)}>{placeholder.description}</button>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <h5 className="mb-2 mt-1">Transfer of Liability Received</h5>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Subject</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <input className="form-control mb-1" type="text" value={transferOfLiabilityReceivedSubject} onChange={(e) => setTransferOfLiabilityReceivedSubject(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-1">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1 mt-1">Content</p>
                                                <small>Write your email content here. Click any placeholder below to insert dynamic content at your cursor position. It will be replaced with real data when the email is sent.</small>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-0">
                                                    <textarea ref={transferOfLiabilityReceivedContentInputRef}  rows={6} className="form-control mb-1" type="text" value={transferOfLiabilityReceivedContent} onChange={(e) => setTransferOfLiabilityReceivedContent(e.target.value)} />
                                                </div>
                                                <div>
                                                    {
                                                        !arrayUtilities.isNullOrEmpty(placeholders) &&
                                                        placeholders.map(
                                                            placeholder => <button className="btn btn-falcon-default btn-xs m-1" onClick={() => stringHelpers.insertTextAtCursorPosition(placeholder.formattedName, transferOfLiabilityReceivedContentInputRef, setTransferOfLiabilityReceivedContent)}>{placeholder.description}</button>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                {emailSettingsInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setEmailsEnabled(settings.emailsEnabled);
                                                        setEmailSenderName(settings.emailSenderName);
                                                        setEmailSenderAddress(settings.emailSenderAddress);
                                                        setAppealReceivedSubject(settings.appealReceivedSubject);
                                                        setAppealReceivedContent(settings.appealReceivedContent);
                                                        setTransferOfLiabilityReceivedSubject(settings.transferOfLiabilityReceivedSubject);
                                                        setTransferOfLiabilityReceivedContent(settings.transferOfLiabilityReceivedContent);
                                                        setAppealAcceptedResponseSubject(settings.appealAcceptedResponseSubject)
                                                        setAppealAcceptedResponseStatus(settings.appealAcceptedResponseStatus ?? "")
                                                        setAppealAcceptedResponseContent(settings.appealAcceptedResponseContent)
                                                        setAppealDeclinedResponseSubject(settings.appealDeclinedResponseSubject)
                                                        setAppealDeclinedResponseStatus(settings.appealDeclinedResponseStatus ?? "")
                                                        setAppealDeclinedResponseContent(settings.appealDeclinedResponseContent)
                                                        setAppealAcceptedResponseResetDateIssued(settings.appealAcceptedResponseResetDateIssued)
                                                        setAppealAcceptedResponseResetCharges(settings.appealAcceptedResponseResetCharges)
                                                        setAppealAcceptedResponseAdditionalCharge(settings.appealAcceptedResponseAdditionalCharge)
                                                        setAppealAcceptedResponseAdditionalChargeType(settings.appealAcceptedResponseAdditionalChargeType)
                                                        setAppealAcceptedResponseDebtRecoveryCharge(settings.appealAcceptedResponseDebtRecoveryCharge)
                                                        setAppealAcceptedResponseDebtRecoveryChargeType(settings.appealAcceptedResponseDebtRecoveryChargeType)
                                                        setAppealDeclinedResponseResetDateIssued(settings.appealDeclinedResponseResetDateIssued)
                                                        setAppealDeclinedResponseResetCharges(settings.appealDeclinedResponseResetCharges)
                                                        setAppealDeclinedResponseAdditionalCharge(settings.appealDeclinedResponseAdditionalCharge)
                                                        setAppealDeclinedResponseAdditionalChargeType(settings.appealDeclinedResponseAdditionalChargeType)
                                                        setAppealDeclinedResponseDebtRecoveryCharge(settings.appealDeclinedResponseDebtRecoveryCharge)
                                                        setAppealDeclinedResponseDebtRecoveryChargeType(settings.appealDeclinedResponseDebtRecoveryChargeType)
                                                        setEmailSettingsInEdit(false)
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col d-flex">
                                            <h5 className="mb-0 mr-2">Device Status Settings</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (deviceStatusInEdit) {
                                                    setCameraStatusWarningThreshold(settings.cameraStatusWarningThreshold)
                                                    setCameraStatusDangerThreshold(settings.cameraStatusDangerThreshold)
                                                    setKioskStatusWarningThreshold(settings.kioskStatusWarningThreshold)
                                                    setKioskStatusDangerThreshold(settings.kioskStatusDangerThreshold)
                                                }
                                                setDeviceStatusInEdit(!deviceStatusInEdit)}
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!deviceStatusInEdit && <>
                                        <div className="row mb-2">
                                            <div className="col-md-3 col-12">
                                                <p className="font-weight-semi-bold mb-1">Camera Status Thresholds (minutes)</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <StatusThresholdRangeSlider
                                                    warningValue={cameraStatusWarningThreshold}
                                                    dangerValue={cameraStatusDangerThreshold}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-3 col-12">
                                                <p className="font-weight-semi-bold mb-1">Kiosk Status Thresholds (minutes)</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <StatusThresholdRangeSlider
                                                    warningValue={kioskStatusWarningThreshold}
                                                    dangerValue={kioskStatusDangerThreshold}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </>}
                                    {deviceStatusInEdit && <>
                                        <div className="row mb-2">
                                            <div className="col-md-3 col-12">
                                                <p className="font-weight-semi-bold mb-1">Camera Status Thresholds (minutes)</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <StatusThresholdRangeSlider
                                                    warningValue={cameraStatusWarningThreshold}
                                                    dangerValue={cameraStatusDangerThreshold}
                                                    onChange={({ warning, danger }) => {
                                                        setCameraStatusWarningThreshold(warning);
                                                        setCameraStatusDangerThreshold(danger);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-3 col-12">
                                                <p className="font-weight-semi-bold mb-1">Kiosk Status Thresholds (minutes)</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <StatusThresholdRangeSlider
                                                    warningValue={kioskStatusWarningThreshold}
                                                    dangerValue={kioskStatusDangerThreshold}
                                                    onChange={({ warning, danger }) => {
                                                        setKioskStatusWarningThreshold(warning);
                                                        setKioskStatusDangerThreshold(danger);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                {deviceStatusInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => {
                                                        setCameraStatusWarningThreshold(settings.cameraStatusWarningThreshold)
                                                        setCameraStatusDangerThreshold(settings.cameraStatusDangerThreshold)
                                                        setKioskStatusWarningThreshold(settings.kioskStatusWarningThreshold)
                                                        setKioskStatusDangerThreshold(settings.kioskStatusDangerThreshold)
                                                        setDeviceStatusInEdit(false);
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel
                                                    </button>
                                                    <button 
                                                    type="button" 
                                                    disabled={
                                                        cameraStatusWarningThreshold === 0
                                                        || cameraStatusDangerThreshold === 0
                                                        || kioskStatusWarningThreshold === 0
                                                        || kioskStatusDangerThreshold === 0
                                                    } 
                                                    className="btn btn-success btn-sm ml-2" 
                                                    onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">Vehicle Data Analytics</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (vehicleAnalyticsInEdit) {
                                                    setVehicleAnalyticsEnabled(settings.vehicleAnalyticsEnabled)
                                                }
                                                setVehicleAnalyticsInEdit(!vehicleAnalyticsInEdit)
                                                setSelectedSites(sitesByClient.filter(item => item.vehicleAnalyticsEnabled).map(item => item.id))

                                            }
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!vehicleAnalyticsInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Enabled</p>
                                            </div>
                                            <div className="col-md-6 col-12 d-flex">
                                                {vehicleAnalyticsEnabled ? <i className="mt-1 fas fa-check text-success"></i>  : <i className="mt-1 fas fa-times text-danger"></i>}
                                            </div>
                                        </div>
                                        {
                                            vehicleAnalyticsEnabled && 
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold  mb-3">Sites</p>
                                                </div>
                                                <div className="col-md-6 col-12 d-flex">
                                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table w-100 border-bottom border-200 no-footer ">
                                                        <thead className="bg-200 text-900">
                                                            <tr>
                                                                <th>Client</th>
                                                                <th>Name</th>
                                                                <th>Code</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                isLoadingSites ? <tr><td className='text-center' colSpan={ 5 }><Loader /></td></tr>
                                                                    : !arrayUtilities.isNullOrEmpty(sitesByClient)
                                                                    && sitesByClient.filter(item => item.vehicleAnalyticsEnabled).map(
                                                                        site => <tr key={ site.id }>
                                                                            <td>{ site.clientName }</td>
                                                                            <td><Link to={ `/organisation/${ props.organisationId }/client/${ site.clientId }/site/${ site.id }` }><h6 className="mb-0">{ site.name }</h6></Link></td>
                                                                            <td>{ site.siteCode }</td>
                                                                        </tr>
                                                                    )
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }
                                    </>}
                                    {vehicleAnalyticsInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Enabled</p>
                                            </div>
                                            <div className="col-md-6 col-12 d-flex align-items-start">
                                                <div className='custom-control custom-switch'>
                                                    <input className="custom-control-input" type="checkbox" id="switch1" checked={vehicleAnalyticsEnabled} onChange={e => setVehicleAnalyticsEnabled(!vehicleAnalyticsEnabled)} />
                                                    <label className="custom-control-label custom-toggle" htmlFor="switch1"></label>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            vehicleAnalyticsEnabled &&
                                            <div className="row mt-2">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold mb-1">Sites</p>
                                                </div>
                                                <div className="col-md-6 col-12 d-flex align-items-start">
                                                    { 
                                                        sitesByClient && 
                                                        <div className='w-100'>
                                                            <div className="d-flex align-items-center mb-2">
                                                                <SearchBarWithDebounce onSearchQueryChange={ query => {
                                                                    setSearchQuery(query)
                                                                    setVehicleAnalyticsPageNumber(0)
                                                                    getSites(query, selectedClient, 0)
                                                                } } />
                                                                <div className='ml-2'>
                                                                    <FiltersModalTrigger onClick={ () => setShowVehicleAnalyticsFiltersModal(true) } />
                                                                </div>
                                                            </div>
                                                            {
                                                                showVehicleAnalyticsFilterPills && vehicleAnalyticsAppliedFilters &&
                                                                <div className="d-flex align-items-center flex-wrap mb-2">
                                                                    {
                                                                        Object.entries(vehicleAnalyticsAppliedFilters).map(
                                                                            ([label, value]) => !stringHelpers.isNullOrEmpty(value)
                                                                            && <div className="mr-2" key={ label }>
                                                                                <AppliedFilterDisplay
                                                                                    label={ label }
                                                                                    onTextClick={ () => setShowVehicleAnalyticsFiltersModal(true) }
                                                                                    onCloseClick={ closedLabel => {
                                                                                        setSelectedClient("")
                                                                                        setVehicleAnalyticsPageNumber(0)
                                                                                        getSites(searchQuery, "", 0)
                                                                                        setVehicleAnalyticsAppliedFilters(prevState => {
                                                                                            const updatedFilters = { ...prevState }
                                                                                            updatedFilters[closedLabel] = null
                                                                                            const hasRemainingFilters = Object.values(updatedFilters).some(value => !stringHelpers.isNullOrEmpty(value))
                                                                                            return hasRemainingFilters ? updatedFilters : null
                                                                                        })
                                                                                    } }
                                                                                    value={ value }
                                                                                />
                                                                            </div>
                                                                        )
                                                                    }
                                                                    { Object.keys(vehicleAnalyticsAppliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={ () => {
                                                                        setSelectedClient("")
                                                                        setVehicleAnalyticsPageNumber(0)
                                                                        setVehicleAnalyticsAppliedFilters(null)
                                                                        getSites(searchQuery, "", 0)
                                                                    } }>Clear all filters</button> }
                                                                </div>
                                                            }
                                                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table w-100 border-bottom border-200 no-footer ">
                                                                <thead className="bg-200 text-900">
                                                                    <tr>
                                                                        <td>
                                                                            <input className="" type="checkbox" checked={ isSelectAllChecked } id="select-all-sites" onChange={
                                                                                event => arrayUtilities.handleSelectAll(event, isSelectAllChecked, setIsSelectAllChecked, () => setSelectedSites([]), () => setSelectedSites(sitesByClient.map(item => item.id))) } />
                                                                        </td>
                                                                        <th>Client</th>
                                                                        <th>Name</th>
                                                                        <th>Code</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        isLoadingSites ? <tr><td className='text-center' colSpan={ 5 }><Loader /></td></tr>
                                                                            : !arrayUtilities.isNullOrEmpty(sitesByClient)
                                                                            && sitesByClient.map(
                                                                                site => <tr key={ site.id }>
                                                                                    <td><input className="" type="checkbox" checked={ selectedSites.includes(site.id) } id={ `select-site-${ site.id }` }
                                                                                        onChange={ event => arrayUtilities.handleListSelection(event.target.checked, site, setSelectedSites, selectedSites, sitesByClient, isSelectAllChecked, setIsSelectAllChecked) } /></td>
                                                                                    <td>{ site.clientName }</td>
                                                                                    <td><h6 className="mb-0 cursor-pointer" onClick={ () => arrayUtilities.handleListSelection(!selectedSites.includes(site.id), site, setSelectedSites, selectedSites, sitesByClient, isSelectAllChecked, setIsSelectAllChecked) }>{ site.name }</h6></td>
                                                                                    <td>{ site.siteCode }</td>
                                                                                </tr>
                                                                            )
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <div className="d-flex justify-content-center row align-items-center pt-2">
                                                                <div className="col-auto align-items-center">
                                                                    <Pagination
                                                                        totalResults={sitesByClient?.length}
                                                                        currentPage={vehicleAnalyticsPageNumber}
                                                                        changePageNumber={number => {
                                                                            getSites(searchQuery, selectedClient, number)
                                                                            setVehicleAnalyticsPageNumber(number)
                                                                        }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </>}
                                </div>
                                {vehicleAnalyticsInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" 
                                                    onClick={() => {
                                                        setVehicleAnalyticsEnabled(settings.vehicleAnalyticsEnabled)
                                                        setVehicleAnalyticsInEdit(!vehicleAnalyticsInEdit)
                                                        setSelectedSites(sitesByClient.filter(item => item.vehicleAnalyticsEnabled).map(item => item.id))
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button disabled={vehicleAnalyticsEnabled && arrayUtilities.isNullOrEmpty(selectedSites)} type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>

                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">Client Portal settings</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => {
                                                if (clientPortalInEdit) {
                                                    setClientAllowedVrmStartDateRequired(settings.clientAllowedVrmStartDateRequired)
                                                }
                                                setClientPortalInEdit(!clientPortalInEdit)
                                            }
                                            }>
                                                <i className="fas fa-edit"></i> Edit</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    {!clientPortalInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Allowed VRM start date required</p>
                                            </div>
                                            <div className="col-md-6 col-12 d-flex">
                                                {clientAllowedVrmStartDateRequired && <i className="mt-1 fas fa-check text-success"></i> }
                                                { !clientAllowedVrmStartDateRequired && <i className="mt-1 fas fa-times text-danger"></i>}
                                            </div>
                                        </div>
                                    </>}
                                    {clientPortalInEdit && <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold mb-1">Allowed VRM start date required</p>
                                            </div>
                                            <div className="col-md-6 col-12 d-flex align-items-start">
                                                <div className='custom-control custom-switch'>
                                                    <input className="custom-control-input" type="checkbox" id="client-allowed-vrm-start-date-required" checked={clientAllowedVrmStartDateRequired} onChange={() => setClientAllowedVrmStartDateRequired(!clientAllowedVrmStartDateRequired)} />
                                                    <label className="custom-control-label custom-toggle" htmlFor="client-allowed-vrm-start-date-required"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                {clientPortalInEdit && <>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div>
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" 
                                                    onClick={() => {
                                                        setClientAllowedVrmStartDateRequired(settings.clientAllowedVrmStartDateRequired)
                                                        setClientPortalInEdit(!clientPortalInEdit)
                                                    }}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </div>
                        </div>
                    </div>
                </div>
                {!stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={errorMessage} onHide={() => setErrorMessage("")} />}
                {
                    showVehicleAnalyticsFiltersModal &&
                    <VehicleDataAnalyticsFiltersModal
                        showModal={ showVehicleAnalyticsFiltersModal }
                        handleClose={ () => setShowVehicleAnalyticsFiltersModal(false) }
                        handleConfirm={ (draftFilters) => {
                            setSelectedClient(draftFilters.selectedClient)
                            setVehicleAnalyticsAppliedFilters(draftFilters.appliedFilters)
                            setShowVehicleAnalyticsFilterPills(true)
                            setShowVehicleAnalyticsFiltersModal(false)
                            setVehicleAnalyticsPageNumber(0)
                            getSites(searchQuery, draftFilters.selectedClient, 0)
                        } }
                        initialSelectedClient={ selectedClient }
                        initialAppliedFilters={ vehicleAnalyticsAppliedFilters }
                        clients={ props.clients }
                        key="vehicle-data-analytics-filters-modal"
                    />
                }
            </>}
            {
                randomStringGenerationConfig &&
                <Modal show onHide={ () => setRandomStringGenerationConfig(null) } centered>
                    <Modal.Header>
                        <Modal.Title className="d-flex gap-2 align-items-center">{randomStringGenerationConfig.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="font-weight-semi-bold mt-1 mb-2">This will generate a new { randomStringGenerationConfig.title }. Are you sure?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={ () => setRandomStringGenerationConfig(null) }>Cancel</Button>
                        <Button size="sm" variant='success' onClick={ randomStringGenerationConfig.onConfirm }>Confirm</Button>
                    </Modal.Footer>
                </Modal>
            }
        </>
    )
}
export default OrganisationSettings;